/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createSin } from '../../factoriesAny.js';
export var sinDependencies = {
  typedDependencies: typedDependencies,
  createSin: createSin
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSin.generated.js
// module id = 523
// module chunks = 0